/**
 * Shared MIS formatting utilities and constants
 */

// Amount thresholds for formatting
export const AMOUNT_SCALE_CRORE = 10000000;
export const AMOUNT_SCALE_LAKH = 100000;
export const AMOUNT_SCALE_THOUSAND = 1000;

export const CHART_COLORS = [
  "#0f766e", "#1e40af", "#9333ea", "#c2410c", "#b91c1c",
  "#ca8a04", "#0891b2", "#4f46e5", "#dc2626", "#059669",
  "#d97706", "#7c3aed",
];

export function fmt(amount) {
  if (amount === undefined || amount === null) return "0.00";
  const abs = Math.abs(amount);
  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);
  return amount < 0 ? `(${formatted})` : formatted;
}

export function fmtShort(amount) {
  const abs = Math.abs(amount || 0);
  if (abs >= AMOUNT_SCALE_CRORE) return `${(amount / AMOUNT_SCALE_CRORE).toFixed(2)} Cr`;
  if (abs >= AMOUNT_SCALE_LAKH) return `${(amount / AMOUNT_SCALE_LAKH).toFixed(2)} L`;
  if (abs >= AMOUNT_SCALE_THOUSAND) return `${(amount / AMOUNT_SCALE_THOUSAND).toFixed(1)} K`;
  return fmt(amount);
}

export function fmtTooltip(val) {
  if (Math.abs(val) >= AMOUNT_SCALE_CRORE) return `${(val / AMOUNT_SCALE_CRORE).toFixed(2)} Cr`;
  if (Math.abs(val) >= AMOUNT_SCALE_LAKH) return `${(val / AMOUNT_SCALE_LAKH).toFixed(2)} L`;
  return fmt(val);
}

export function monthLabel(m) {
  if (!m) return "";
  const [, mo] = m.split("-");
  const months = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return months[parseInt(mo)] || m;
}
